import { Layout, CameraSettings } from "components"
export const Cameras = () => {
 return (
  <Layout>
   <CameraSettings />
  </Layout>
 )
}
